import { Session } from "../session/session";

export class SessionRessource {
    sessionKey: number;
    ressourceKey: number[];

    constructor(sessionKey: number, ressourceKey: number[]) {
        this.sessionKey = sessionKey;
        this.ressourceKey = ressourceKey;
    }
}

export class SessionTrainee {
    previousSessionKey: number;
    nextSessionKey: number;
    sessionTraineeKey: number;
    userKey: number;

    constructor(previousSessionKey: number, nextSessionKey: number, sessionTraineeKey: number, userKey: number) {
        this.previousSessionKey = previousSessionKey;
        this.nextSessionKey = nextSessionKey;
        this.sessionTraineeKey = sessionTraineeKey;
        this.userKey = userKey;
    }
}

export class Planing {
  clubRessourceFirstName: string;
  clubRessourceKey: number;
  clubRessourceLastName: string;
  clubRessourcePseudo: string;
  sessions: any[];

  constructor(clubRessourceFirstName: string, clubRessourceKey: number, clubRessourceLastName: string, clubRessourcePseudo: string, sessions: any[]) {
      this.clubRessourceFirstName = clubRessourceFirstName;
      this.clubRessourceKey = clubRessourceKey;
      this.clubRessourceLastName = clubRessourceLastName;
      this.clubRessourcePseudo = clubRessourcePseudo;
      this.sessions = sessions;
  }
}

export class SessionTraineeHistory {
  historyKey: number;
  offerName: string;
  sessionTraineeKey: number;
  oldSession: Session;
  newSession: Session;
  trainee: string;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  isCustomerNotified: boolean;
  notifierUserName?: string;
  plannerUserName?: string;

  constructor(historyKey: number, offerName: string, sessionTraineeKey: number, oldSession: Session, newSession: Session, trainee: string, customerFirstName: string, customerLastName: string, customerEmail: string, isCustomerNotified: boolean) {
      this.historyKey = historyKey;
      this.offerName = offerName;
      this.sessionTraineeKey = sessionTraineeKey;
      this.oldSession = oldSession;
      this.newSession = newSession;
      this.trainee = trainee;
      this.customerFirstName = customerFirstName;
      this.customerLastName = customerLastName;
      this.customerEmail = customerEmail;
      this.isCustomerNotified = isCustomerNotified;
  }
}
